import React, { useState } from 'react';
import Loader from '../../assets/loader1.gif';
import PhoneInput from 'react-phone-number-input';
import toast from 'react-hot-toast';

import { FP, LoaderSpan } from './Elements';
import { CustomGreenLargeButton } from '../../components/Button';
import { FormHelperText } from '@mui/material';
import { signInWithPhoneNumber } from 'firebase/auth';
import { authentication } from '../../firebase';
import { useRecaptcha } from '../../hooks/useRecaptcha';
import api from '../../api';
import { CustomLabel2 } from '../../components/InputFields/Elements';

const Phone = ({ setStep, handleScreen }) => {
  const { generateRecaptcha, forceReset } = useRecaptcha();
  const [state, setState] = useState({
    phoneCountryCode: 'US',
    phone: '',
    loading: false,
  });
  const handleChange = (name, value) => {
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const [isPhoneError, setPhoneError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const submitFunction = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    if (state?.phone) {
      handleChange('loading', true);
      
      try {
        const appVerifier = await generateRecaptcha();
        
        await api.get(`user/verifyPhoneNumber?phone=${state?.phone.replace("+","").trim()}`);
        
        const confirmationResult = await signInWithPhoneNumber(authentication, state?.phone, appVerifier);
        window.confirmationResult = confirmationResult;
        handleScreen('phone', state?.phone);
        toast.success(`Otp sent to ${state?.phone}`, { duration: 4000 });
        setStep(2);
        handleChange('loading', false);
             } catch (error) {
         console.log(error.code);
         
         // If it's a reCAPTCHA error, force reset and try again once
         if (error.message.includes('reCAPTCHA has already been rendered')) {
           console.log('reCAPTCHA error detected, forcing reset...');
           forceReset();
           try {
             // Wait a bit and try again
             await new Promise(resolve => setTimeout(resolve, 500));
             const appVerifier = await generateRecaptcha();
             await api.get(`user/verifyPhoneNumber?phone=${state?.phone.replace("+","").trim()}`);
             const confirmationResult = await signInWithPhoneNumber(authentication, state?.phone, appVerifier);
             window.confirmationResult = confirmationResult;
             handleScreen('phone', state?.phone);
             toast.success(`Otp sent to ${state?.phone}`, { duration: 4000 });
             setStep(2);
             handleChange('loading', false);
             return;
           } catch (retryError) {
             console.log('Retry also failed:', retryError);
             toast.error('Please try again in a moment.', { duration: 4000 });
             handleChange('loading', false);
             return;
           }
         }
         
                   if (error.message == 'Firebase: TOO_LONG (auth/invalid-phone-number).') {
            toast.error('Invalid phone number.  Please try again', { duration: 4000 });
          } else if (error.message == 'Firebase: TOO_SHORT (auth/invalid-phone-number).') {
            toast.error('Invalid phone number.  Please try again', { duration: 4000 });
          } else if (error.message == "Firebase: Error (auth/billing-not-enabled)."){
            toast.error('Billing not Enabled', { duration: 4000 });
          } else if (error.message == "Firebase: Error (auth/too-many-requests)."){
            toast.error('Too many requests. Please wait a moment before trying again.', { duration: 4000 });
          } else if (error.response?.data?.message) {
            toast.error(error.response.data.message, { duration: 4000 });
          } else {
            toast.error('Please try again.', { duration: 4000 });
          }
         handleChange('loading', false);
       } finally {
        setIsLoading(false);
        handleChange('loading', false);
      }
    } else {
      setPhoneError(true);
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={submitFunction} className="submitForm">
      <div id="recaptcha-container"></div>
      <div>
        <CustomLabel2>Phone Number</CustomLabel2>
        <PhoneInput
          defaultCountry={state?.phoneCountryCode}
          international
          countryCallingCodeEditable={false}
          placeholder="Enter phone number"
          value={state?.phone}
          onChange={(e) => handleChange('phone', e)}
        />
      </div>
      {isPhoneError ? (
        <FormHelperText
          sx={{
            fontFamily: 'Poppins-Medium',
            color: '#d32f2f',
            marginTop: 0,
          }}
        >
          {'Phone is required'}
        </FormHelperText>
      ) : null}
      <FormHelperText sx={{ fontFamily: 'Poppins-Medium', color: '#d32f2f', marginTop: 0 }}>
        {state?.error}
      </FormHelperText>

      <CustomGreenLargeButton
        type="submit"
        variant="contained"
        disableripple
        disabled={state?.loading || isLoading}
      >
        {' '}
        {state?.loading || isLoading ? (
          <LoaderSpan>
            <img src={Loader} width={30} alt="loading..." style={{ marginRight: 6 }} />
            Send Code
          </LoaderSpan>
        ) : (
          'Send Code'
        )}{' '}
      </CustomGreenLargeButton>

      <div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
        <FP
          onClick={() => {
            handleScreen('withPhone', false);
            handleScreen('withEmail', true);
          }}
        >
          Use Email Address instead
        </FP>
      </div>
    </form>
  );
};
export default Phone;
